import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import History from 'static/script/utils/history';
import fullPath from 'static/script/utils/full-path';

function SearchResultHeaderUI() {

    this.defaultAttrs({
        sortButtonSelector: '[data-form-select-select]',
        selectBoxSelector: '[data-form-select]'
    });

    this._fixQueryStringInHistory = function (evt, data) {
        let expand = data.expand;

        if (!expand && window.Feature.detected.history) {
            History.pushState({}, document.title, fullPath().replace('&expanded=1', ''));
        }
    };

    this._sortChanged = function (evt) {
        let url = $(evt.target).find(':selected').data('url');
        let newSearchOrder = $(evt.target).find(':selected').text() || '';
        let callbackDone = false;

        let hitCallback = function () {
            if (callbackDone === false) { // callback should never be ran twice (ipad issue when using hitCallback + setTimeout)
                this.trigger(document, 'ui:navigate', { href: url });
            }
            callbackDone = true;
        }.bind(this);

        this.trigger(document, 'analytics:track-event', {
            category: 'Search Filters',
            action: 'Sort order change',
            label: newSearchOrder,
            hitCallback: hitCallback
        });

        setTimeout(function () {
            hitCallback();
        }, 1000);
    };

    this.after('initialize', function () {
        this.on(document, 'ui:toggle:search-filters ui:toggle:search-filters-categories', this._fixQueryStringInHistory);

        this.on('change', {
            sortButtonSelector: this._sortChanged
        });
    });
}

export default  defineComponent.component(SearchResultHeaderUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/search-result-header-ui.js